import React, { useCallback, useState } from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useLocation, useNavigate } from "react-router-dom";

import BulkCsvImportDialog from "../CandidateManagement/BulkCsvImportDialog";
import logger from "../../utils/logger";

// Jobs that are still open for candidates — same set the open-jobs list uses.
export const OPEN_JOB_STATUSES = Object.freeze(["Active", "Partially-Fulfilled", "Critical"]);

const ICON_SX = { color: "#2777AA" };

/**
 * Candidate actions for one job row in My Jobs: view the job's candidates,
 * add a candidate (job pre-selected) and bulk upload candidates (CSV/Excel).
 * Shown only while the job is open for candidates.
 */
const JobCandidateActions = ({ job }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [csvDialogOpen, setCsvDialogOpen] = useState(false);
  const from = location.pathname + location.search;

  const viewCandidates = useCallback(() => {
    logger.debug(`[MyJobs] Viewing candidates of ${job.job_code}.`);
    navigate("/admindashboard/adminAccordion", { state: { jobCode: job.job_code, from } });
  }, [navigate, job.job_code, from]);

  const addCandidate = useCallback(() => {
    logger.debug(`[MyJobs] Adding a candidate to ${job.job_code}.`);
    navigate("/candidate_data/addCandidate", { state: { jobCode: job.job_code, from } });
  }, [navigate, job.job_code, from]);

  if (!OPEN_JOB_STATUSES.includes(job.job_status)) {
    return null;
  }

  return (
    <Stack direction="row" sx={{ whiteSpace: "nowrap" }}>
      <Tooltip title="View candidates">
        <IconButton size="small" onClick={viewCandidates}>
          <RemoveRedEyeIcon sx={ICON_SX} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Add candidate">
        <IconButton size="small" onClick={addCandidate}>
          <PersonAddAlt1Icon sx={ICON_SX} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Bulk upload candidates (CSV/Excel)">
        <IconButton size="small" onClick={() => setCsvDialogOpen(true)}>
          <UploadFileIcon sx={ICON_SX} />
        </IconButton>
      </Tooltip>
      <BulkCsvImportDialog
        open={csvDialogOpen}
        onClose={() => setCsvDialogOpen(false)}
        jobCode={job.job_code}
        pipelineType={job.pipeline_type}
      />
    </Stack>
  );
};

export default JobCandidateActions;
